const Players = {
  WHITE: "white",
  BLACK: "black",
};

export default Players;
